import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "../style/About.css";

const AboutUs = () => {
  const [employees, setEmployees] = useState([]);
  const [expandedCards, setExpandedCards] = useState([]);

  useEffect(() => {
    fetch("https://randomuser.me/api/?results=6")
      .then((response) => response.json())
      .then((data) => setEmployees(data.results));
  }, []);

  const toggleCardExpansion = (index) => {
    if (expandedCards.includes(index)) {
      setExpandedCards(expandedCards.filter((i) => i !== index));
    } else {
      setExpandedCards([...expandedCards, index]);
    }
  };

  const isCardExpanded = (index) => expandedCards.includes(index);
  return (
    <>
      <Container>
        <iframe
          width="1268"
          height="713"
          src="https://www.youtube.com/embed/BjDHdf1Vd0E"
          title="THE FLASH – New Trailer (2023) Ben Affleck, Michael Keaton, Ezra Miller Movie | Warner Bros"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
        <h1 className="abt-tittle">About Us</h1>
        <Row>
          {employees.map((employee, index) => (
            <Col key={index} md={4}>
              <Card className="my-3 shadow employee-card">
                <Card.Img
                  variant="top"
                  src={employee.picture.large}
                  className="employee-card-image"
                />
                <Card.Body className="employee-card-body">
                  <Card.Title className="title-card">
                    {employee.name.first + " " + employee.name.last}
                  </Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">
                    {employee.email}
                  </Card.Subtitle>
                  <Card.Text className="employee-card-text">
                    {isCardExpanded(index)
                      ? employee.location.city +
                        ", " +
                        employee.location.country +
                        ". " +
                        employee.phone +
                        ". " +
                        employee.email +
                        ". " +
                        employee.position +
                        ". "
                      : employee.location.city +
                        ", " +
                        employee.location.country +
                        ". "}
                    <Button
                      variant="link"
                      className="p-0 ml-1 employee-card-button"
                      onClick={() => toggleCardExpansion(index)}
                    >
                      {isCardExpanded(index) ? "Read less" : "Read more"}
                    </Button>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/*-----------Start of Footer----------- */}
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <p>&copy; 2023 Roland Ajeti. All Rights Reserved.</p>
            </div>
            <div className="col-md-6">
              <ul className="footer-links">
                <li>
                  <a href="home" className="anchor">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="home" className="anchor">
                    Terms of Use
                  </a>
                </li>
                <li>
                  <a href="home" className="anchor">
                    Contact Us
                  </a>
                </li>
              </ul>
              <ul className="social-icons">
                <li>
                  <a
                    href="https://www.instagram.com/rolandajeti/"
                    aria-label="Take a look at my Instagram Profile"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={["fab", "instagram"]} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/in/roland-ajeti-834335207/"
                    aria-label="Take a look at my LinkedIn Profile"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={["fab", "linkedin"]} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCA7Tj3B9h2FikEHcEJI4cnQ"
                    aria-label="Take a look at my Youtube Profile"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={["fab", "youtube"]} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/RolandAjeti"
                    target={"_blank"}
                    rel="noreferrer"
                    aria-label="Take a look at my Twitter Profile"
                  >
                    <FontAwesomeIcon icon={["fab", "twitter"]} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://rolandajeti-portfolio-website.netlify.app/"
                    aria-label="Take a look at my Portfolio Website"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={faBriefcase} />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      {/*-----------End of Footer----------- */}
    </>
  );
};

export default AboutUs;
